<template>
  <el-dialog title='新增' :visible.sync='dialogVisible' :close-on-click-modal='false'
             @close='dialogClose' width='600px'>
    <el-form :model='form' label-width='130px' label-position='right' :rules='rules'
             ref='ruleForm' class='settlement-form mt20'>
      <el-form-item label='上下水：' prop='flowType'>
        <el-select v-model='form.flowType' size='mini' filterable style='width:100%'
                   placeholder='请选择上下水' value-key='id'>
          <el-option v-for='(item) in flowTypeOptions' :key='item.value' :label='item.label'
                     :value='item.value' />
        </el-select>
      </el-form-item>
      <el-form-item label='运价类型：' prop='freightType'>
        <el-select v-model='form.freightType' size='mini' filterable style='width:100%'
                   placeholder='请选择运价类型' value-key='id'>
          <el-option v-for='(item) in freightTypeOptions' :key='item.value' :label='item.label'
                     :value='item.value' />
        </el-select>
      </el-form-item>
      <el-form-item label='委托商：' prop='customerId'>
        <el-select v-model='form.customerId' size='mini' filterable style='width:100%'
                   placeholder='请选择委托商' value-key='id'>
          <el-option v-for='(item) in consignorOption' :key='item.id' :label='item.customer_name'
                     :value='item.id' />
        </el-select>
      </el-form-item>
      <el-form-item label='线路：' prop='lineId'>
        <el-select v-model='form.lineId' size='mini' filterable style='width:100%'
                   placeholder='请选择线路' value-key='id'>
          <el-option v-for='(item) in lineOptions' :key='item.id' :label='item.line_name'
                     :value='item.id' />
        </el-select>
      </el-form-item>
      <el-form-item label='品牌：'>
        <el-select v-model='form.brandId' size='mini' multiple
                   collapse-tags filterable style='width:100%'
                   placeholder='请选择品牌' value-key='id'>
          <el-option v-for='(item) in brandOptions' :key='item.id' :label='item.brand'
                     :value='item.id' />
        </el-select>
      </el-form-item>
      <el-form-item label='税率：'>
        <el-input v-model='form.taxRate' size='mini' type='number' placeholder='请输入税率'>
          <template slot='append'>%</template>
        </el-input>
      </el-form-item>
      <el-form-item label='江运单价：' prop='riverTransportationUnitPrice'>
        <el-input v-model='form.riverTransportationUnitPrice' size='mini' type='number'
                  placeholder='请输入江运单价' />
      </el-form-item>
      <el-form-item label='结算起止时间：' prop='startAndEnd'>
        <el-date-picker
          size='mini'
          v-model='form.startAndEnd'
          value-format='yyyy-MM-dd'
          type='daterange'
          align='right'
          unlink-panels
          range-separator='至'
          start-placeholder='开始日期'
          end-placeholder='结束日期'
          :picker-options='pickerOptions'>
        </el-date-picker>
      </el-form-item>

      <div class='flex-center-center mt20 mb20'>
        <el-button size='medium' class='searchBtn' :loading='submitLoading' @click='submit'>确认
        </el-button>
        <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import { commercialCarPriceAdd, customerInfoSelectList } from '@/service/financial';
  import { publicSelectLine, yearSelectBrandByAll } from '@/service/vehiclelog';

  export default {
    name: 'commercialCarPriceForm',
    data() {
      return {
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          }],
        },
        dialogVisible: false,
        defaultForm: {},
        form: {
          flowType: '',
          freightType: '',
          customerId: '',
          lineId: '',
          brandId: '',
          taxRate: '',
          riverTransportationUnitPrice: '',
          startAndEnd: [],
        },
        rules: {
          flowType: [
            {
              required: true,
              message: '请选择上下水',
              trigger: 'blur',
            },
          ],
          freightType: [
            {
              required: true,
              message: '请选择运价类型',
              trigger: 'blur',
            },
          ],
          customerId: [
            {
              required: true,
              message: '请输入委托商',
              trigger: 'blur',
            },
          ],
          lineId: [
            {
              required: true,
              message: '请选择线路',
              trigger: 'blur',
            },
          ],
          riverTransportationUnitPrice: [
            {
              required: true,
              message: '请输入江运单价',
              trigger: 'blur',
            },
          ],
          startAndEnd: [
            {
              required: true,
              message: '请输入结算起止时间',
              trigger: 'blur',
            },
          ],
        },
        submitLoading: false,
        flowTypeOptions: [{
          label: '上水',
          value: '0',
        }, {
          label: '下水',
          value: '1',
        }],
        freightTypeOptions: [{
          label: '普通运价',
          value: '0',
        }, {
          label: '固定运价',
          value: '1',
        }],
        lineOptions: [],
        consignorOption: [],
        brandOptions: [],
      };
    },
    mounted() {
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
    },
    methods: {
      async getLineOptions() {
        const {
          status,
          message,
          data,
        } = await publicSelectLine({ type: 2 });
        if (status !== 0) return this.$message.warning(message);
        this.lineOptions = data;
      },
      async getConsignorOptions() {
        let {
          status,
          message,
          data,
        } = await customerInfoSelectList();
        if (status !== 0) return this.$message.error(message);
        this.consignorOption = data;
      },
      async getBrandOptions() {
        let {
          status,
          message,
          data,
        } = await yearSelectBrandByAll();
        if (status !== 0) return this.$message.error(message);
        this.brandOptions = data;
        console.log(data);
      },
      dialogOpen(id) {
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
        id ? this.form.id = id : '';
        this.getLineOptions();
        this.getConsignorOptions();
        this.getBrandOptions();
        this.dialogVisible = true;
      },
      dialogClose() {
        this.dialogVisible = false;
      },
      submit() {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            this.form.settlementStartTime = this.form.startAndEnd[0];
            this.form.settlementEndTime = this.form.startAndEnd[1];
            this.submitLoading = true;
            const {
              status,
              message,
            } = await commercialCarPriceAdd({
              ...this.form,
              brandId: this.form.brandId.length > 0 ? this.form.brandId.join(',') : '',
            });
            this.submitLoading = false;
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            this.$emit('searchBtn');
            this.dialogClose();
          }
        });
      },
    },
  };
</script>

<style lang='scss' scoped>
  .settlement-form {
    width: 80%;
    margin: 0 auto;
  }
</style>
